import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import * as confetti from 'canvas-confetti';

@Injectable()
export class ToastService {
  private toastDuration = 3000;
  private toastErrorClass = 'error-toast';
  private toastWarningClass = 'warning-toast';
  private toastSuccessClass = 'success-toast';

  constructor(private toastCtrl: ToastController) {}

  public showErrorToastOnTop(message: string, showToast = true): void {
    if (showToast) {
      this.presentCustomToast(message, this.toastDuration, 'top', this.toastErrorClass);
    } else {
      console.error(message);
    }
  }

  public showWarningToastOnTop(message: string, toastDuration?: number, toastWarningClass?: string): void {
    this.presentCustomToast(
      message,
      toastDuration ? toastDuration : this.toastDuration,
      'top',
      toastWarningClass ? toastWarningClass : this.toastWarningClass
    );
  }

  public showSuccessToastOnTop(message: string): void {
    this.presentCustomToast(message, this.toastDuration, 'top', this.toastSuccessClass);
  }

  public dismissToast() {
    this.toastCtrl.dismiss();
  }

  public generateConfettiCanvasId(): string {
    const canvasId = `canvasRef${Math.random()
      .toString()
      .slice(0, 6)
      .replace('.', '')}`;
    return canvasId;
  }

  public fireConfetti(canvas) {
    const myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: true,
    });
    myConfetti({
      particleCount: 100,
      spread: 160,
    });
  }

  private presentCustomToast(
    message: string,
    duration: number,
    position: 'top' | 'bottom' | 'middle',
    cssClass: string,
    showDismissButton: boolean = false // Optional parameter to control if dismiss button is shown
  ): void {
    const buttons = showDismissButton
      ? [
          {
            text: 'Dismiss',
            role: 'cancel',
            handler: () => {
              console.log('Toast dismissed');
            },
          },
        ]
      : [];

    this.toastCtrl
      .create({
        message,
        duration,
        position,
        cssClass,
        buttons, // Add buttons only if showDismissButton is true
      })
      .then((toast) => {
        toast.present();
      });
  }
}
